import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, FormControl, FormHelperText, IconButton, InputLabel, Link, MenuItem, Select, Tooltip, } from "@material-ui/core";
import { Edit, Pageview } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import { getPlaylistTooltipAndURL } from "./shared";
var useStyles = makeStyles({
    select: {
        "& a": {
            visibility: "hidden",
        },
    },
    menuItem: {
        "& a": {
            visibility: "hidden",
        },
        "&:hover a": {
            visibility: "visible",
        },
    },
});
export var PlaylistEntryPlaylistSelect = function (_a) {
    var playlists = _a.playlists, selectedPlaylistId = _a.selectedPlaylistId, onChange = _a.onChange, error = _a.error;
    var classes = useStyles();
    var playlistId = selectedPlaylistId === -1 ? "" : selectedPlaylistId;
    var changePlaylist = function (evt) {
        if (typeof evt.target.value === "string") {
            var value = parseInt(evt.target.value);
            if (!isNaN(value)) {
                onChange(value);
            }
        }
        else if (typeof evt.target.value === "number") {
            onChange(evt.target.value);
        }
    };
    return (React.createElement(FormControl, { fullWidth: true },
        React.createElement(InputLabel, null, "\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0439 \u043F\u043B\u0435\u0439\u043B\u0438\u0441\u0442"),
        React.createElement(Select, { className: classes.select, fullWidth: true, value: playlistId, onChange: changePlaylist, error: !!error }, playlists.map(function (playlist) {
            var _a = getPlaylistTooltipAndURL(playlist), tooltip = _a.tooltip, url = _a.url, isEditable = _a.isEditable;
            return (React.createElement(MenuItem, { className: classes.menuItem, key: playlist.id, value: playlist.id },
                playlist.title,
                React.createElement(Tooltip, { title: tooltip },
                    React.createElement(Link, { to: url, target: "_blank", component: RouterLink, onClick: function (e) {
                            e.stopPropagation();
                        } },
                        React.createElement(Box, { style: { display: "inline" }, ml: 1 },
                            React.createElement(IconButton, { size: "small" }, isEditable ? React.createElement(Edit, null) : React.createElement(Pageview, null)))))));
        })),
        error && React.createElement(FormHelperText, { error: true }, error)));
};
